import React from "react";

interface Props {}

const ElevatorPitch: React.FC<Props> = () => {
    return (
        <p>
            I'm a software engineer at Google on the Open Source Security team.
            I love learning something about everything 📚.
        </p>
    );
};

export default ElevatorPitch;
